import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import { useNavigate } from 'react-router-dom';

const AgentCampaignsPage = () => {
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    loadCampaigns();
  }, []);

  const loadCampaigns = async () => {
    try {
      setLoading(true);
      
      const { data: { user } } = await supabase.auth.getUser();
      
      if (!user) return;

      const { data: agentLinks } = await supabase
        .from('campaign_agents')
        .select('campaign_id')
        .eq('agent_id', user.id);

      if (!agentLinks || agentLinks.length === 0) {
        setCampaigns([]);
        return;
      }

      const campaignIds = agentLinks.map(item => item.campaign_id);
      const { data: campaignsData } = await supabase
        .from('campaigns')
        .select('*')
        .in('id', campaignIds);

      setCampaigns(campaignsData || []);
    } catch (error) {
      console.error('Erreur:', error);
    } finally {
      setLoading(false);
    }
  };

  const styles = {
    pageContainer: {
      backgroundColor: '#f3f4f6',  // fond gris clair
      minHeight: '100vh',
      padding: '24px'
    },
    header: {
      marginBottom: '24px'
    },
    title: {
      fontSize: '24px',
      fontWeight: 'bold',
      color: '#111827',  // texte noir
      marginBottom: '8px'
    },
    subtitle: {
      color: '#4b5563',  // texte gris foncé
      fontSize: '14px'
    },
    loadingText: {
      color: '#111827',  // texte noir
      fontSize: '16px'
    },
    emptyContainer: {
      backgroundColor: 'white',
      borderRadius: '8px',
      padding: '48px',
      textAlign: 'center',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
    },
    emptyEmoji: {
      fontSize: '48px',
      marginBottom: '16px'
    },
    emptyTitle: {
      fontSize: '18px',
      fontWeight: '500',
      color: '#111827',  // texte noir
      marginBottom: '8px'
    },
    emptyText: {
      color: '#6b7280'  // texte gris
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
      gap: '24px'
    },
    card: {
      backgroundColor: 'white',
      borderRadius: '8px',
      padding: '24px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      cursor: 'pointer',
      transition: 'box-shadow 0.2s',
      border: '1px solid #e5e7eb'
    },
    cardTitle: {
      fontSize: '18px',
      fontWeight: '600',
      color: '#111827',  // texte noir
      marginBottom: '8px'
    },
    cardDescription: {
      color: '#4b5563',  // texte gris foncé
      fontSize: '14px',
      marginBottom: '16px'
    },
    cardFooter: {
      display: 'flex',
      justifyContent: 'space-between',
      color: '#6b7280',  // texte gris
      fontSize: '14px'
    },
    cardStatus: {
      display: 'inline-block',
      padding: '4px 8px',
      backgroundColor: '#dbeafe',
      color: '#1e40af',  // texte bleu foncé
      borderRadius: '4px',
      fontSize: '12px',
      marginTop: '12px'
    }
  };

  if (loading) {
    return (
      <div style={styles.pageContainer}>
        <div style={styles.header}>
          <h1 style={styles.title}>Mes campagnes</h1>
          <p style={styles.subtitle}>Chargement des données...</p>
        </div>
        <div style={styles.loadingText}>Chargement en cours...</div>
      </div>
    );
  }

  return (
    <div style={styles.pageContainer}>
      <div style={styles.header}>
        <h1 style={styles.title}>Mes campagnes</h1>
        <p style={styles.subtitle}>Sélectionnez une campagne pour voir ses leads</p>
      </div>

      {campaigns.length === 0 ? (
        <div style={styles.emptyContainer}>
          <div style={styles.emptyEmoji}>📢</div>
          <h3 style={styles.emptyTitle}>Aucune campagne assignée</h3>
          <p style={styles.emptyText}>Vous n'avez pas encore de campagnes à traiter.</p>
        </div>
      ) : (
        <div style={styles.grid}>
          {campaigns.map((campaign) => (
            <div
              key={campaign.id}
              onClick={() => navigate(`/leads?campaign=${campaign.id}`)}
              style={styles.card}
              onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.1)'}
              onMouseLeave={(e) => e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)'}
            >
              <h3 style={styles.cardTitle}>{campaign.name}</h3>
              {campaign.description && (
                <p style={styles.cardDescription}>{campaign.description}</p>
              )}
              <div style={styles.cardFooter}>
                <span>📊 {campaign.leads_count || 0} leads</span>
                <span>📅 {new Date(campaign.created_at).toLocaleDateString()}</span>
              </div>
              <div style={styles.cardStatus}>
                {campaign.status}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AgentCampaignsPage;
